import React, { useEffect, useState } from "react";
import {
  SmileDesignForm,
  SmileDesignProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputNew";
import SelectInput from "../formComp/SelectInputNew";
import ToothField from "../formComp/ToothField";

const SmileDesign: React.FC<SmileDesignProps> = ({
  onChange,
  hidePhotoIncluded = false,
}) => {
  const [form, setForm] = useState<SmileDesignForm>({
    toothNumbers: [],
    photoIncluded: hidePhotoIncluded ? "Yes" : "",
    biteOpening: "",
    teethExtractions: [],
    waxUp: "",
    proposedTreatmentPlan: "",
    otherConsiderations: "",
  });

  const handleToothClick = (
    type: "toothNumbers" | "teethExtractions",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof SmileDesignForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-[var(--cu-text)]">
      <div className="mb-3 border-b border-[var(--cu-border)] pb-2">
        <h2 className="text-sm font-medium text-[var(--cu-accent)]">
          Smile Design
        </h2>
      </div>

      <div className="w-full space-y-3">
        <ToothField
          label="Tooth #s"
          toothNumbers={form.toothNumbers}
          onToothClick={(tooth) => handleToothClick("toothNumbers", tooth)}
        />

        {!hidePhotoIncluded && (
          <SelectInput
            label="Photo Included"
            name="photoIncluded"
            value={form.photoIncluded}
            onChange={(e) => handleChange("photoIncluded", e.target.value)}
            options={[
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ]}
          />
        )}

        <TextInput
          optional
          label="Change In Vertical Dimension"
          name="biteOpening"
          value={form.biteOpening}
          onChange={(e) => handleChange("biteOpening", e.target.value)}
        />

        <ToothField
          label="Teeth to be extracted (if any)"
          optional
          toothNumbers={form.teethExtractions}
          onToothClick={(tooth) => handleToothClick("teethExtractions", tooth)}
        />

        <SelectInput
          label="Wax Up"
          name="waxUp"
          value={form.waxUp}
          onChange={(e) => handleChange("waxUp", e.target.value)}
          options={[
            {
              value: "Additive wax up (no additional tooth prep)",
              label: "Additive wax up (no additional tooth prep)",
            },
            {
              value: "Restorative wax up (tooth prep to be done)",
              label: "Restorative wax up (tooth prep to be done)",
            },
          ]}
        />

        <SelectInput
          label="Proposed Treatment Plan"
          name="proposedTreatmentPlan"
          value={form.proposedTreatmentPlan}
          onChange={(e) =>
            handleChange("proposedTreatmentPlan", e.target.value)
          }
          options={[
            { value: "Crown and Bridge", label: "Crown and Bridge" },
            { value: "Veneer", label: "Veneer" },
            { value: "Implant", label: "Implant" },
            { value: "Composite Bonding", label: "Composite Bonding" },
          ]}
        />
        <TextInput
          optional
          label="Other Considerations"
          name="otherConsiderations"
          value={form.otherConsiderations}
          onChange={(e) => handleChange("otherConsiderations", e.target.value)}
        />
      </div>
    </div>
  );
};

export default SmileDesign;
